import { Policy } from '../../../../types/types';
import { ALLOW_FORWARDING, ALLOW_FORWARDING_IN_DOMAIN } from '@/consts';

export interface ForwardingStatus {
    isForwardingEnabled: boolean;
    isDomainForwardingEnabled: boolean;
    shouldShowWarning: boolean;
}

/**
 * Check if a policy has forwarding enabled
 */
export const checkPolicyForwardingStatus = (policy: Policy | null): ForwardingStatus => {
    if (!policy?.settings?.access) {
        return {
            isForwardingEnabled: false,
            isDomainForwardingEnabled: false,
            shouldShowWarning: false,
        };
    }

    const forwardingSetting = policy.settings.access.find(
        (setting) => setting.id === ALLOW_FORWARDING
    );
    const domainForwardingSetting = policy.settings.access.find(
        (setting) => setting.id === ALLOW_FORWARDING_IN_DOMAIN
    );

    const isForwardingEnabled = !!(forwardingSetting?.value);
    const isDomainForwardingEnabled = !!(domainForwardingSetting?.value);
    const shouldShowWarning = isForwardingEnabled || isDomainForwardingEnabled;

    return {
        isForwardingEnabled,
        isDomainForwardingEnabled,
        shouldShowWarning,
    };
};
